import Vue from 'vue';
import Vuex from 'vuex';
import { PaymentSettings } from './modules/PaymentSettings';
import { PaymentCalculator } from './modules/PaymentCalculator';
import { FinancingPageDetails } from './modules/FinancingPageDetails';
import { MyTradeValuePageDetails } from './modules/MyTradeValuePageDetails';
import { ScheduleTestDrivePageDetails } from './modules/ScheduleTestDrivePageDetails';
import { ExpressPaymentSettings } from './modules/ExpressPaymentSettings';
import { GoogleMapStore } from './modules/GoogleMapStore';
import { SellUsYourCarPageDetails } from './modules/SellUsYourCarPageDetails';
import { KeyFeatureStore } from './modules/KeyFeatureStore';
import { ScheduleServicePage } from './modules/ScheduleServicePage';
import { TransactDetails } from './modules/TransactStore';
import { XTimeScheduleServicePage } from './modules/XTimeScheduleServicePage';
import { InventoryFilterSettings } from './modules/InventoryFilterSettings';
import { CommonSettingsStore } from './modules/CommonSettingsStore';
import { BannersDataStore } from './modules/BannersDataStore';
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    paymentsettings: PaymentSettings,
    paymentcalculator: PaymentCalculator,
    financepagedetails: FinancingPageDetails,
    mytradevaluedetails: MyTradeValuePageDetails,
    scheduleTestDrivePageDetails: ScheduleTestDrivePageDetails,
    expressPaymentSettings: ExpressPaymentSettings,
    googleMapStore: GoogleMapStore,
    sellusyourcardetails: SellUsYourCarPageDetails,
    keyFeatureStore: KeyFeatureStore,
    scheduleservicepage: ScheduleServicePage,
    transactpopupdata: TransactDetails,
    inventoryfiltersettings: InventoryFilterSettings,
    XTimeScheduleServicePage: XTimeScheduleServicePage,
    commonSettings: CommonSettingsStore,
    bannersData: BannersDataStore,
  },
});

export default store;
